import {Location} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../../../environments/environment.prod';
import {
    AlignmentOption,
    CreatorSection,
    defaultAlignOptions,
    defaultDirectionTypes,
    defaultMemberTypes,
    defaultProportions,
    defaultSectionTypes,
    defaultTags,
    DirectionType,
    MemberType,
    ModelTag,
    ObjectProportions,
    SectionType
} from '../../../models/CreatorModels';
import {CommonService} from '../../../services/common.service';
import {ConsentsFormService} from '../../../services/consents-form.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {FormPropertiesDialogComponent} from './form-properties-dialog/form-properties-dialog.component';

@Component({
    selector: 'app-temp-custom-form-creator',
    templateUrl: './temp-custom-form-creator.component.html',
    styleUrls: ['./temp-custom-form-creator.component.scss']
})
export class TempCustomFormCreatorComponent implements OnInit {
    memberTypes: MemberType[] = defaultMemberTypes;
    directionTypes: DirectionType[] = defaultDirectionTypes;
    formTypes = environment.productSchoolId !== 1 ? [{id: 1, label: 'Δήλωση συναίνεσης'}, {id: 2, label: 'Δήλωση εγγραφής'}, {id: 10, label: 'Δημόσια / Ανώνυμη δήλωση'}] : [{id: 1, label: 'Δήλωση συναίνεσης'}, {id: 2, label: 'Δήλωση εγγραφής'}];
    sectionTypes: SectionType[] = defaultSectionTypes;
    alignmentOptions: AlignmentOption[] = defaultAlignOptions;
    objectProportions: ObjectProportions[] = defaultProportions;
    formDescription: string;
    formTitle: string;
    formType: any;
    formSubmitMessage = '';
    form: any;
    mode: boolean;
    numberOfSections: number;
    uniqueId: string;
    isLoading: boolean;
    columnMaxHeight: number;
    sections: CreatorSection[] = [];
    properties: any;
    height: number;
    expanded: number;
    defaultSection: CreatorSection;
    defaultMemberTags: ModelTag[] = defaultTags;
    constructor(public dialog: MatDialog,
                public location: Location,
                public route: ActivatedRoute,
                private router: Router,
                private consentFormService: ConsentsFormService,
                public toastMessagesService: ToastMessagesService,
                private commonService: CommonService) {
        this.expanded = 1;
        this.height = window.innerHeight - 300;
        this.numberOfSections = 1;
        this.formDescription = '';
        this.formTitle = '';
        this.isLoading = true;
        this.defaultSection =  {
            id: 1,
            expanded: true,
            displayed: true,
            title: '',
            type: this.sectionTypes[0],
            label: 'Τίτλος',
            value: `Tίτλος τμήμα ${this.sections.length + 1}`,
            subLabel: 'Yπότιτλος',
            subLabelValue: '',
            direction: this.directionTypes[0],
            members: [],
            align: this.alignmentOptions[0]
        };
        this.columnMaxHeight = window.innerHeight - 104;
        this.initProperties();
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(async (params) => {
            this.mode = params.mode === 'true';
            // this.loadFormLocalStorage();
            this.uniqueId = params.uniqueId;

            // Έλεγχος αν ερχόμαστε από AI Form Creator
            if (params.fromAI === 'true') {
                this.loadAIContent();
                return;
            }

            if (this.mode) {
                await this.initializeForm(params.uniqueId);
            } else {
                this.loadFormLocalStorage();
            }
        });
    }

    loadAIContent() {
        const aiText = localStorage.getItem('aiGeneratedContent');
        if (aiText) {
            // Καθαρισμός κειμένου: αφαίρεση γραμμών με παύλες (___) και κενών γραμμών
            let cleanedText = aiText
                .replace(/_{3,}/g, '')  // Αφαίρεση γραμμών ____
                .replace(/\n{3,}/g, '\n\n');  // Μείωση πολλαπλών κενών γραμμών

            // Regex για split με headers τύπου ** ΤΙΤΛΟΣ ** ή **ΤΙΤΛΟΣ** (με ή χωρίς κενά)
            const headerRegex = /\*\*\s*([^*]+?)\s*\*\*/g;
            const parts = cleanedText.split(headerRegex);

            this.sections = [];
            let sectionId = 1;
            let firstTitle = '';

            // Αν υπάρχει κείμενο πριν τον πρώτο header
            if (parts[0] && parts[0].trim()) {
                this.sections.push(this.createAISection(sectionId++, 'Εισαγωγή', this.cleanContent(parts[0])));
            }

            // Δημιουργία sections για κάθε header
            // Τα πεδία (headers με :) προστίθενται ως ξεχωριστά members στο τρέχον section
            let currentSection: CreatorSection = null;
            let memberIdCounter = 1;

            for (let i = 1; i < parts.length; i += 2) {
                let title = parts[i] ? parts[i].trim() : `Ενότητα ${sectionId}`;
                const content = parts[i + 1] ? this.cleanContent(parts[i + 1]) : '';

                // Αν ο τίτλος τελειώνει με : είναι πεδίο (member), όχι section
                const isField = title.endsWith(':');

                if (isField) {
                    // Αφαίρεση : από το τέλος
                    title = title.slice(0, -1).trim();

                    // Αν υπάρχει τρέχον section, πρόσθεσε το πεδίο ως νέο member
                    if (currentSection) {
                        currentSection.members.push({
                            id: ++memberIdCounter,
                            type: this.memberTypes.find(t => t.id === 7), // label
                            align: this.alignmentOptions[0],
                            proportion: this.objectProportions.find(p => p.id === 4), // 100%
                            title: title,
                            value: content || '',
                            mandatory: false,
                            options: []
                        });
                    } else {
                        // Αν δεν υπάρχει section, δημιούργησε ένα με τα πεδία
                        currentSection = this.createAISection(sectionId++, 'Πεδία', title);
                        if (content) {
                            currentSection.members[0].value = content;
                        }
                        memberIdCounter = 1;
                    }
                } else {
                    // Είναι νέο section - αποθήκευσε το προηγούμενο αν υπάρχει
                    if (currentSection) {
                        this.sections.push(currentSection);
                    }

                    // Αποθήκευση του πρώτου τίτλου για τον τίτλο της δήλωσης
                    if (!firstTitle && title) {
                        firstTitle = title;
                    }

                    // Δημιουργία νέου section
                    currentSection = this.createAISection(sectionId++, title, content || title);
                    memberIdCounter = 1;
                }
            }

            // Αποθήκευση του τελευταίου section
            if (currentSection) {
                this.sections.push(currentSection);
            }

            // Αν δεν βρέθηκαν headers, δημιουργία ενός section με όλο το κείμενο
            if (this.sections.length === 0) {
                this.sections.push(this.createAISection(1, 'AI Δήλωση', this.cleanContent(aiText)));
                firstTitle = 'AI Δήλωση';
            }

            // Ο πρώτος τίτλος γίνεται ο τίτλος της δήλωσης, κενή περιγραφή
            this.formTitle = firstTitle || 'AI Δημιουργημένη Δήλωση';
            this.formDescription = '';
            localStorage.removeItem('aiGeneratedContent');
            this.toastMessagesService.toastMessages(`Δημιουργήθηκαν ${this.sections.length} ενότητες`);
        } else {
            this.sections.push(this.defaultSection);
        }
    }

    cleanContent(text: string): string {
        return text
            .replace(/_{3,}/g, '')  // Αφαίρεση παυλών
            .replace(/-{3,}/g, '')  // Αφαίρεση dashes
            .replace(/\n{3,}/g, '\n\n')  // Μείωση κενών γραμμών
            .trim();
    }

    createAISection(id: number, title: string, content: string): CreatorSection {
        return {
            id: id,
            expanded: true,
            displayed: true,
            title: '',
            type: this.sectionTypes[0],
            label: 'Τίτλος',
            value: title,
            subLabel: 'Υπότιτλος',
            subLabelValue: '',
            direction: this.directionTypes[0],
            align: this.alignmentOptions[0],
            members: [
                {
                    id: 1,
                    type: this.memberTypes.find(t => t.id === 7), // label
                    align: this.alignmentOptions[0],
                    proportion: this.objectProportions.find(p => p.id === 4), // 100%
                    title: content,
                    value: '',
                    mandatory: false,
                    options: []
                }
            ]
        };
    }

    loadFormLocalStorage() {
        try {
            const tempStoredForm = JSON.parse(localStorage.getItem('storedForm'));
            const tempSections = JSON.parse(tempStoredForm.sections);

            this.sections = tempSections;
            for (const section of this.sections) {
                section.align = this.alignmentOptions.find(a => a.id === section.align.id);
                section.type = this.sectionTypes.find(s => s.id === section.type.id);
                for (const member of section.members) {
                    member.type = this.memberTypes.find(t => t.id === member.type.id);
                    member.proportion = this.objectProportions.find(p => p.id === member.proportion.id);
                }
            }
        } catch (e) {
            console.log('first init');
            this.sections.push(this.defaultSection);
        }
    }

    handledExpandedSection($event) {
        this.expanded = $event;
    }

    initProperties() {
        this.properties = {
            has_two_factor: false,
            automations: null,
            has_deadline: false,
            deadline_date: null,
            has_max_slots: false,
            max_slots: null,
            canParentEdit: true,
            hasUploadField: false
        };
    }

    async initializeForm(uniqueId: string) {
        try {
            this.form = await this.consentFormService.getCustomFormByUniqueId(uniqueId);
            if (this.form) {
                this.formTitle = this.form.title;
                this.formDescription = this.form.description;
                this.sections = JSON.parse(this.form.sections);
                this.formSubmitMessage = this.form.submit_message;
                this.formType = this.formTypes.find(type => type.id === this.form.form_type_id);

                this.properties.automations = this.form.automations;
                this.properties.has_two_factor = this.form.has_two_factor === 1;
                this.properties.canParentEdit = this.form.canParentEdit === 1;
                this.properties.has_max_slots = this.form.has_max_slots === 1;
                this.properties.has_deadline = this.form.has_deadline === 1;
                this.properties.deadline_date = this.form.deadline_date;
                this.properties.max_slots = this.form.max_slots ? this.form.max_slots : 0;
                this.properties.checkbox_limit = this.form.checkbox_limit || null;
                this.properties.hasUploadField = this.form.hasUploadField === 1;

                for (const section of this.sections) {
                    section.expanded = false;
                    section.title = section.title ? section.title.replace(/'/g, '\'\'') : '';

                    for (const member of section.members) {
                        if (member.tag) {
                            const tag = this.defaultMemberTags.find(t => t.id === member.tag.id);
                            member.tag = tag;
                        }
                        if (member.proportion) {
                            const tempValue = member.proportion.value;
                            const proportion = this.objectProportions.find(prop => prop.id === member.proportion.id);
                            member.proportion = proportion;
                            member.proportion.value = tempValue;
                        }
                        if (member.align) {
                            const tempValue = member.align.value;
                            const align = this.alignmentOptions.find(alignment => alignment.id === member.align.id);
                            member.align = align;
                            member.align.value = tempValue;
                        }
                        member.title = member.title ? member.title.replace(/'/g, '\'\'') : '';
                        const type = this.memberTypes.find(t => t.id === member.type.id);
                        if (type) {
                            member.type = type;
                        }
                    }
                }
            }
        } catch (e) {
            console.log(e);
            this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να αρχικοποιήσουμε την δήλωση');
        } finally {
            this.isLoading = false;
        }
    }

    isFormInValid() {
        if (!this.formDescription && !this.formDescription && !this.formType) {
            return true;
        } else {
            return false;
        }
    }

    async submitForm() {
        const model = {
            formTitle: this.formTitle,
            formDescription: this.formDescription,
            formType: this.formType,
            submit_message: this.formSubmitMessage,
            sections: JSON.stringify(this.sections),
            options: JSON.stringify(this.properties)
        };
        try {
            // localStorage.setItem('storedForm', JSON.stringify(model));
            await this.commonService.insertItem('forms/custom-add', model);
            localStorage.removeItem('storedForm');
            // Navigate στη σελίδα Δηλώσεις αντί για location.back()
            await this.router.navigate(['/home/forms']);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async updateForm() {
        const model = {
            formId: this.form.id,
            formTitle: this.formTitle,
            formDescription: this.formDescription,
            formType: this.formType,
            submitMessage: this.formSubmitMessage,
            sections: JSON.stringify(this.sections),
            options: JSON.stringify(this.properties)
        };
        try {
            // localStorage.setItem('storedForm', JSON.stringify(model));
            await this.commonService.updateItem('forms/custom', model);
            localStorage.removeItem('storedForm');
            this.location.back();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να ενημερώσουμε την φόρμα. Ελέγξτε για πιθανά (\'\') ');
        }
    }

    tempSave() {
        const model = {
            formTitle: this.formTitle,
            formDescription: this.formDescription,
            sections: JSON.stringify(this.sections)
        };

        try {
            localStorage.setItem('storedForm', JSON.stringify(model));
            this.toastMessagesService.toastMessages(
                'Η φόρμα αποθηκεύτηκε προσωρινά'
            );
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    openSettings() {
        const propertiesDialog = this.dialog.open(FormPropertiesDialogComponent, {
            data: this.properties
        });
    }

    setSections() {
        const defaultSection = {
            id: this.sections.length + 1,
            label: 'Τίτλος',
            value: `Tίτλος τμήμα ${this.sections.length + 1}`,
            subLabel: 'Yπότιτλος',
            subLabelValue: '',
            title: '',
            direction: this.directionTypes[0],
            members: [],
            expanded: true,
            displayed: true,
            type: this.sectionTypes[0],
            align: this.alignmentOptions[0]
        };
        this.sections.push(defaultSection);
    }
}
